import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "orderBy",
})

export class OrderByPipe implements PipeTransform {
	transform<T>(value: T[], property: string): T[] {
		if (!value || !property) {
			return value;
		}

		return value.sort((a, b) => {
			const aValue = (a as Record<string, unknown>)[property] as string | number;
			const bValue = (b as Record<string, unknown>)[property] as string | number;

			if (aValue < bValue) {
				return -1;
			} else if (aValue > bValue) {
				return 1;
			} else {
				return 0;
			}
		});
	}
}
